//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImgTools from './_img_tools'
import AudioPlayer from './_audio_player'
import { layoutToConsult } from '../_layout/layout_consult'
export default {
    components: {
        AudioPlayer,
        ImgTools
    },
    props: {
        url: Object,
        playing: Boolean,
        duration: Number,
        running_time: Number,
        name: String,
        building_id: [String, Number],
        show_consult: {
            type: Boolean,
            default: false
        },
        from: String,
    },
    computed: {
        tag_list () {
            return this.url.tag_list && this.url.tag_list.slice(0, 3)
        }
    },
    methods: {
        openVrWithLog () {
            this.$sendCtmEvtLog('户型列表-VR看房点击')
            this.openVr()
        },
        consultDetail() {
            this.$sendCtmEvtLog('户型列表-咨询点击')
            this.consult()
        },
        consult () {
            layoutToConsult(this.building_id, this.from, this.url.id)
        },
        preview () {
            this.$emit('preview')
        },
        play () {
            this.$emit('play')
        },
        stop () {
            this.$emit('stop')
        },
        goVideo (url) {
            this.$emit('goVideo', this.url.video_url)
        },
        openVr () {
            this.$emit('openVr', this.url.vr_link)
        },
        seek (percent) {
            this.$emit('seek', percent)
        },
        goBuildingPrice(building) {
            const {id, price_house_id } = building
            this.$router.push({
                path:`/building/price?building_id=${id}&title=${this.name}&house_id=${price_house_id}&building_image_id=${id}`
            })
        }
    }
}
